export const GENERAL_SETTINGS_ENTITY_NAME = 'settings.user.settings.general';
